/**
 * SITE CONFIG
 * ─────────────────────────────────────────────────────────────────────────────
 * All non-translatable, admin-editable data lives here.
 * In production every key maps 1:1 to a Firestore document field.
 *
 * Admin Panel → Firestore → fetch on page load → replace this static config.
 *
 * Firestore collection: `siteConfig`
 * Document: `homepage`
 */

export const SITE_CONFIG = {
  brand: {
    name: 'BITAKAS',
    // Admin uploads logo → Firebase Storage URL replaces null
    logoUrl: null,
    copyrightText: '© 2026 Bitakas. All rights reserved.',
    copyrightTextTr: '© 2026 Bitakas. Tüm hakları saklıdır.',
  },

  // ── Hero Slider ────────────────────────────────────────────────────────────
  // Admin uploads banner images via CMS. Each item: { imageUrl: string }
  // Image dimensions target: 1920×700px landscape (same ratio as reference)
  // object-fit: cover ensures any size fills the frame correctly.
  hero: {
    autoplayInterval: 5500, // ms — admin can tune
    slides: [
      {
        id: 'slide-1',
        // Replace imageUrl with Firebase Storage download URL in production:
        // imageUrl: 'https://firebasestorage.googleapis.com/v0/b/bitakas.../banner1.jpg'
        imageUrl: null,           // null → CSS gradient fallback renders
        fallbackGradient: 'linear-gradient(135deg, #0a0a2e 0%, #1718BF 50%, #D60B0B 100%)',
      },
      {
        id: 'slide-2',
        imageUrl: null,
        fallbackGradient: 'linear-gradient(135deg, #D60B0B 0%, #0a0a2e 60%, #1718BF 100%)',
      },
      {
        id: 'slide-3',
        imageUrl: null,
        fallbackGradient: 'linear-gradient(135deg, #1718BF 0%, #D60B0B 50%, #0a0a2e 100%)',
      },
    ],
  },

  // ── Categories ──────────────────────────────────────────────────────────────
  // Admin adds/removes/reorders via CRUD panel.
  // `icon` is a Lucide icon component name (string key).
  // `nameKey` maps to TRANSLATIONS[lang].categoryNames[nameKey]
  categories: [
    { id: 'electronics', icon: 'Laptop'     },
    { id: 'phone',       icon: 'Phone'      },
    { id: 'fashion',     icon: 'Shirt'      },
    { id: 'sports',      icon: 'Dumbbell'   },
    { id: 'home',        icon: 'Sofa'       },
    { id: 'auto',        icon: 'Car'        },
    { id: 'gaming',      icon: 'Gamepad2'   },
    { id: 'baby',        icon: 'Baby'       },
    { id: 'pets',        icon: 'PawPrint'   },
    { id: 'tools',       icon: 'Wrench'     },
    { id: 'books',       icon: 'BookOpen'   },
    { id: 'watches',     icon: 'Watch'      },
    { id: 'jewelry',     icon: 'Gem'        },
    { id: 'music',       icon: 'Music'      },
    { id: 'camera',      icon: 'Camera'     },
  ],

  // ── Featured Listings (images only) ────────────────────────────────────────
  // Admin uploads listing showcase images.
  // In production: { imageUrl: 'https://firebasestorage...' }
  // Disabled for now — placeholders shown.
  listings: {
    isDisabled: true, // admin toggles to false when ready to show real listings
    items: [
      { id: 'l1', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #1a1a3a, #2a2a5a)' },
      { id: 'l2', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #2a1a1a, #4a2a2a)' },
      { id: 'l3', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #1a2a1a, #2a4a2a)' },
      { id: 'l4', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #2a2a1a, #4a4a2a)' },
      { id: 'l5', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #1a1a2a, #3a2a4a)' },
      { id: 'l6', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #2a1a2a, #4a2a3a)' },
      { id: 'l7', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #1a2a2a, #2a3a4a)' },
      { id: 'l8', imageUrl: null, fallbackGradient: 'linear-gradient(135deg, #2a1a3a, #3a2a4a)' },
    ],
  },

  // ── Pricing ────────────────────────────────────────────────────────────────
  // Admin edits prices from CMS → updates Firestore → reflected here on next load.
  pricing: {
    regularPrice: '$X',
    proPrice: '$X',
  },

  // ── Social Links ───────────────────────────────────────────────────────────
  socialLinks: [
    { platform: 'Twitter / X', url: '#', label: '𝕏' },
    { platform: 'Instagram',   url: '#', label: 'IG' },
  ],

  // ── App Download ──────────────────────────────────────────────────────────
  links: {
    appStore:  '#', // admin updates when app is live
    playStore: '#',
  },
};
